module.exports = __webpack_public_path__ + "annualreview2017/static/img/uk-power-networks@2x.01f598e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uk-power-networks@2x.png
// module id = 365
// module chunks = 0